(ns app.toolbox.register
  "UI register entries for the toolbox slice."
  (:require [app.toolbox.page :as page]
            [app.toolbox.request-modal :as request-modal]))

(def register
  [page/page
   request-modal/modal])
